import { isArray } from 'util';
import { IOption } from 'ng-select';

import { Employee } from '../employee';

const createOptionItem = (employee: Employee): IOption => ({ value: employee.hash, label: employee.fullname });

export class EmployeeBuilder {

  static fromJson(json): Employee {
    return (json)
      ? new Employee(
        json.hash,
        json.firstname,
        json.lastname,
        json.email,
        json.birthDate,
        json.password,
        json.active,
        json.admin,
        json.salary
      )
      : null;
  }

  static fromJsonList(list): Employee[] {
    return (isArray(list)) ? list.map(EmployeeBuilder.fromJson) : [];
  }

  static createOptions(employees: Employee[]): IOption[] {
    return (employees) ? employees.map(createOptionItem) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/builders/employee.builder.ts